<template>
  <header>
    <img src="./../assets/img/title.png" />
    <div>
      <h2>정성을 다해 떡을 빚는 호치민 1호 떡집</h2>
      <h1>나경떡집</h1>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
};
</script>
<style lang="scss" scoped>
@import "@/assets/utils/scss/fluid-typo.scss";
header {
  position: relative;
  width: 100%;
  img {
    width: 100%;
    min-width: 300px;
    height: auto;
    display: block;
  }
  div {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    h2 {
      margin: 0;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1), 0 0 2px rgba(0, 0, 0, 0.25);
      @include fluid-type(320px, 1600px, 10px, 30px);
      font-weight: bold;
      line-height: 1.6;
      letter-spacing: -0.8px;
      text-align: center;
      color: #ffffff;
    }

    h1 {
      margin: 10px 0 0 0;
      @include fluid-type(320px, 1600px, 23px, 69px);
      text-shadow: 0 1px 4px rgba(13, 12, 12, 0.32);
      font-weight: 800;
      color: #ffffff;
      text-align: center;
    }
  }
}
</style>
